module.exports = __webpack_public_path__ + "img/img_option_sample.14d45195.png";